import { isTaskKind, kindLabel } from './notice.js';

// Tamizar el historial del pulso: por tipo, por quién lo hizo, y en qué orden.
//
// SE TAMIZA LO QUE YA LLEGÓ. El pulso guarda las últimas `FEED_SIZE` filas —es
// un pulso, no un archivo— y filtrar contra el servidor volvería a pedir la
// lista, que es justo lo que esta pantalla no hace: pide una vez y después
// escucha. Así que esto es una lente sobre lo cargado, y la pantalla dice
// «N de M cargados» para que nadie lea el resultado como el total.
//
// PURO: sin React y sin red, probado sin navegador.

export const AUTHOR_FILTERS = [
    { value: '',          label: 'Cualquiera' },
    { value: 'agente',    label: 'Agentes' },
    { value: 'persona',   label: 'Personas' },
    { value: 'sin-autor', label: 'Sin autor registrado' },
];

export const ORDERS = [
    { value: 'nuevos', label: 'Lo más nuevo primero' },
    { value: 'viejos', label: 'Lo más viejo primero' },
];

// Un movimiento lo hizo un AGENTE cuando lleva credencial, y una PERSONA cuando
// lleva usuario y no credencial: un token pertenece a alguien, así que el
// usuario está en los dos casos y lo que distingue es el token.
function authorOf(row) {
    if (row.tokenId != null) return 'agente';
    if (row.userId != null) return 'persona';
    return 'sin-autor';
}

// Los tipos que hay EN LO CARGADO, con cuántos de cada uno. Ofrecer un tipo que
// no está en la lista es ofrecer un filtro que solo puede dar vacío.
export function kindsPresent(rows) {
    const counts = new Map();
    for (const row of rows ?? []) {
        counts.set(row.kind, (counts.get(row.kind) ?? 0) + 1);
    }
    return [...counts.entries()]
        .map(([kind, count]) => ({ kind, count, label: kindLabel(kind) }))
        .sort((a, b) => a.label.localeCompare(b.label, 'es'));
}

export function filterMovements(rows, { kind = '', author = '', order = 'nuevos' } = {}) {
    const list = (rows ?? []).filter(row => {
        // `task` no es un tipo del backend: es «cualquiera de los de tarea»,
        // que es como se mira esta pantalla cuando se mira el trabajo.
        if (kind === 'task' && !isTaskKind(row.kind)) return false;
        if (kind && kind !== 'task' && row.kind !== kind) return false;
        if (author && authorOf(row) !== author) return false;
        return true;
    });

    // Las filas llegan de la más nueva a la más vieja. Se invierte una COPIA:
    // ordenar en el lugar movería la lista que guarda la consulta.
    return order === 'viejos' ? [...list].reverse() : list;
}
